var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm.cuIconList.length > 0
      ? _c("div", { staticClass: "grid-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "cu-list grid",
              class: ["col-" + _vm.gridCol, _vm.gridBorder ? "" : "no-border"]
            },
            _vm._l(_vm.cuIconList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "cu-item",
                  on: {
                    click: function($event) {
                      _vm.gridClick(item, index)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "image-box" }, [
                    _c("img", { attrs: { src: item.img } })
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.name))])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "gridBtn", on: { click: _vm.btnClick } },
            [_vm._v(_vm._s(_vm.btnTxt) + " >")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }